/**************************************************************************************************/
/*   File: /src/app/shared/models/breadcrumb.fragment.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday January 25th 2019                                                       */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The breadcrumb fragment
 */
export class BreadcrumbFragment {
    /**
     * The breadcrumb fragment array
     */
    path: string[];
    /**
     * The key
     */
    key: string;
}